import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex w-full px-4 py-6" }
const _hoisted_3 = {
  key: 0,
  class: "h-10 flex justify-center w-full"
}
const _hoisted_4 = {
  key: 1,
  class: "flex"
}
const _hoisted_5 = { class: "flex flex-col divide-brand-dark-gray space-y-4 overflow-y-scroll" }

import {onMounted, Ref, ref} from 'vue';
import ApiService from "@/services/api/apiService";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import UserListItem from "@/components/UserListItem.vue";
import {modalController} from "@ionic/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PartnerUsersList',
  props: {
  userId: {
    type: Number,
    required: true
  }
},
  setup(__props) {


const props = __props

const loading = ref(true)

onMounted(async () => {
  await getPartners()
  loading.value = false
})

const users: Ref<UserBasicInformationInterface[]> = ref([])

const getPartners = async () => {
  users.value = await ApiService.User().getPartnersForUser(props.userId)
}

const viewUserProfile = async (user: UserBasicInformationInterface) => {
  await modalController.dismiss(user)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("svg", {
              class: "animate-spin h-5 w-5 m-auto text-white",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }),
              _createElementVNode("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              })
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                return (_openBlock(), _createBlock(UserListItem, {
                  onClick: ($event: any) => (viewUserProfile(user)),
                  key: user.id,
                  user: user
                }, null, 8, ["onClick", "user"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "safe-area-bottom" }, null, -1))
  ]))
}
}

})